import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles/';

/**
 * Styled wrapper component for the dashboard card.
 */
const DashboardCard = styled(MuiCard)(({ theme }) => ({
	borderRadius: '8px',
	transition: '0.4s',
	border: `1px solid ${theme.palette.divider}`,
}));

export default DashboardCard;
